export default "<!--Реализация простого поиска в app-search-header-->\n";